import { useEffect, useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import api from '../api/axios';
import Cookies from 'js-cookie';

const Home = () => {
  const [activeTab, setActiveTab] = useState('principal');
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const token = Cookies.get('access_token');
    if (!token) return;

    api.get('/user')
      .then((res) => {
        setPermissions(res.data.permissions || []);
      })
      .catch(() => {
        setPermissions([]);
      });
  }, []);

  const canViewReports = permissions.includes('reports.view');

  return (
    <div className="mt-4">

      {!canViewReports && (
        <p className="text-center text-muted">
          No tiene permisos para ver el Observatorio.
        </p>
      )}

      {canViewReports && (
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
          fill
        >
          <Tab eventKey="principal" title="Observatorio TI">
            <iframe
              title="Observatorio TI"
              src="https://biamco.sitesas.com/superset/dashboard/2"
              width="100%"
              height="900"
              style={{ border: '0' }}
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            ></iframe>
          </Tab>

          <Tab eventKey="secundario" title="Observatorio TPC - Operación">
            <iframe
              title="Observatorio TPC - Operación"
              src="https://lookerstudio.google.com/embed/reporting/ecb19b37-7d8d-4424-bb90-72605a4d2d60/page/p_6m0h6jw4kd"
              width="100%"
              height="900"
              style={{ border: '0' }}
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            ></iframe>
          </Tab>

          <Tab eventKey="terciario" title="Observatorio TPC - Paraderos">
            <iframe
              title="Observatorio TPC - Movilización"
              src="https://lookerstudio.google.com/embed/reporting/3be5ba05-e71b-4b8b-9e71-1170d34d6b20/page/p_i8pw5ypyzd"
              width="100%"
              height="900"
              style={{ border: '0' }}
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            ></iframe>
          </Tab>
        </Tabs>
      )}
    </div>
  );
};

export default Home;
